exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".display-html img {\n  width: 100%; }\n\n.display-html p, .display-html h1, .display-html h2, .display-html h3, .display-html h4, .display-html h5 {\n  margin: 0px;\n  word-wrap: break-word; }\n", ""]);

// exports
